import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const items = [
    "NO TELEMETRY",
    "ENCRYPTED KERNEL",
    "AUSTRALIAN OWNED",
    "ZERO KNOWLEDGE",
    "HAND HARDENED IN SYDNEY",
    "GRAPHENE OS",
  ];
  return (
    <section aria-label="brand-marquee" className="border-y border-[#1A1A1A] py-10 bg-[#030303]" data-testid="section-marquee">
      <Marquee gradient={false} speed={30} pauseOnHover={false}>
        {items.concat(items).map((t, i) => (
          <span key={i} className="font-display uppercase text-[#444] text-5xl md:text-6xl tracking-tight mx-8">
            {t} <span className="text-[#7C3AED] mx-2">/</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
